import React from 'react';
import { Divider, List } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import NavGroup from './FuseNavGroup';
import NavCollapse from './FuseNavCollapse';
import NavItem from './FuseNavItem';
import NavLink from './FuseNavLink';

const Navigation = props => {
	const { navigation, layout, active, dense, className } = props;

	const Nav = (
		<List className={clsx('navigation whitespace-no-wrap', className)}>
			{navigation.map(item => (
				<React.Fragment key={item.id}>
					{item.type === 'group' && <NavGroup item={item} nestedLevel={0} active={active} dense={dense} />}

					{item.type === 'collapse' && <NavCollapse item={item} nestedLevel={0} active={active} dense={dense} />}

					{item.type === 'item' && <NavItem item={item} nestedLevel={0} active={active} dense={dense} />}

					{item.type === 'link' && <NavLink item={item} nestedLevel={0} active={active} dense={dense} />}

					{item.type === 'divider' && <Divider className="my-16" />}
				</React.Fragment>
			))}
		</List>
	);

	if (navigation.length > 0) {
		switch (layout) {
			case 'vertical':
			default: {
				return Nav;
			}
		}
	} else {
		return null;
	}
};

Navigation.propTypes = {
	navigation: PropTypes.array.isRequired
};

Navigation.defaultProps = {
	layout: 'vertical'
};

export default React.memo(Navigation);
